<template>
	<div>
		<b-form-checkbox :type="type" :id="id" :disabled="!active" v-model="proxyValue" @change="changed">
			{{ label }}
		</b-form-checkbox>
		<b-form-invalid-feedback :id="`${name}-feedback`">
			{{ errors[name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			required: true
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		},
		id: {
			type: String
		},
		value: {
			type: [String, Boolean]
		},
		name: {
			type: String
		},
		errors: {
			type: Object
		},
		label: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			active: true
		};
	},
	beforeMount() {
		if (typeof this.isActive == "function") this.active = this.isActive(null);
		else this.active = this.isActive;
	},
	methods: {
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
			}
		},
		changed: function () {
			this.$emit("checkChange", this.name);
		}
	},
	computed: {
		proxyValue: {
			get() {
				return this.value;
			},
			set(newValue) {
				this.$emit("input", newValue);
			}
		}
	}
};
</script>
